import type { EnumType } from "~/kernel/enums/EnumType";

/**
 * The way this service is used in a booking.
 * - main: the service can be booked by itself.
 * - addOn: the service must be booked alongside another service
 **/
export const ServiceBookingRole = Object.freeze({
  Main: "main",
  AddOn: "addOn",
});

export type ServiceBookingRole = EnumType<typeof ServiceBookingRole>;
